<template>
    <div class="index_mobile">
        <transition name="slide-fade">
            <top_mobile v-show="topshow"></top_mobile>
        </transition>
        <div style="background:#005f88;height:42px;"></div>
        <div class="slide1">
            <img src="../../public/statics/img/banner.gif" alt="">
<!--            <img src="../../public/statics/img/mobile/icon_you.png" @click="toapply()" alt="" class="slide1img02">-->
            <img src="../../public/statics/img/apply.png" @click="toapply()" alt="" class="slide1img02">


            <img src="../../public/statics/img/indexfont.png" alt="" class="slide1img01">
            <div class="slide1bot">
                <div class="slide1bots">
                    <p>商业SaaS+交易平台</p>
                    <span>Bussiness SaaS</span>
                </div>
                <div class="slide1botsb"></div>
                <div class="slide1bots">
                    <p>全场景</p>
                    <span>Full scene</span>
                </div>
                <div class="slide1botsb"></div>
                <div class="slide1bots">
                    <p>一体化</p>
                    <span>Integration</span>
                </div>
            </div>
        </div>
        <div class="slide2">
            <img src="../../public/statics/img/index/SAAS.png" alt="" class="slide2img">
            <div class="slide2font">
                <div class="slide2font1"></div>
                <div class="slide2font2">商业SaaS+交易平台</div>
                <div class="slide2font3">
                    IDA不仅仅是一个高效的管理工具。IDA在满足用户管理赋能的同时，为用户实现市场赋能。
                    IDA利用平台整合效应，充分链接外部平台产业资源和物流资源，为3PL和车主拓展市场，获取海量订单。
                </div>
            </div>
        </div>
        <div class="slide2">
            <img src="../../public/statics/img/index/all.jpg" alt="" class="slide2img">
            <div class="slide2font">
                <div class="slide2font1"></div>
                <div class="slide2font2">全物流场景操作</div>
                <div class="slide2font3">
                    IDA满足用户整车、零担、配送、陆运、空运、海运及多联式物流业务需求。
                    随着供应链全场景物流时代的来临，IDA云平台打破传统TMS的单一运输场景模式，聚焦于用户的全物流业务服务场景。
                </div>
            </div>
        </div>
        <div class="slide2">
            <img src="../../public/statics/img/index/bannner2.jpg" alt="" class="slide2img">
            <div class="slide2font">
                <div class="slide2font1"></div>
                <div class="slide2font2"> 一体化物流管理</div>
                <div class="slide2font3">
                    IDA无缝实现仓储、运输、包装环节的EDI数据交互。
                    IDA把TMS/WMS/CMS整合在一个平台，实现运输、仓储、包装的信息化闭环管理；让用户充分享受协同、高效带来的管理应用价值。
                </div>

            </div>
        </div>
        <div class="slide2">
            <img src="../../public/statics/img/index/5G.jpg" alt="" class="slide2img">
            <div class="slide2font">
                <div class="slide2font1"></div>
                <div class="slide2font2">5G+IoT技术应用</div>
                <div class="slide2font3">
                    IDA真正实现物流全程无断点货物跟踪。
                    IDA充分运用5G和IoT技术，通过手机APP、GPS设备、智能硬件，使整个运输过程透明可见，让用户真实体会到“运筹帷幄，决胜千里”的管理体验。
                </div>


            </div>
        </div>
        <div class="slide2">
            <img src="../../public/statics/img/index/web.jpg" alt="" class="slide2img">
            <div class="slide2font">
                <div class="slide2font1"></div>
                <div class="slide2font2">移动终端全覆盖</div>
                <div class="slide2font3">
                    IDA实现物流现场操作数据的实时同步。
                    IDA通过移动终端将3PL现场人员、货主、车主和收货人实现操作信息实时同步，打破传统信息壁垒，使整个物流过程透明化，方便多方同步高效决策。
                </div>
            </div>
        </div>
        <div class="slide2">
            <img src="../../public/statics/img/index/it.jpg" alt="" class="slide2img">
            <div class="slide2font">
                <div class="slide2font1"></div>
                <div class="slide2font2">IT-DT-AI设计理念</div>
                <div class="slide2font3">
                    IDA协助用户逐步实现物流管理从IT(信息化)到DT(大数据)、AI(智能化)的转型升级。
                    IDA采用先进的产品开发技术和创新理念，利用行业领先的数据架构、AI算法、智能硬件，重塑物流管理模式，全方位助力用户实现物流数字化和智能化升级。
                </div>
            </div>
        </div>
        <div class="slide4">
            <div class="slide4title1">资讯中心</div>
            <div class="slide4title2">NEWS</div>
            <div class="slide4s">
                <img src="../../public/statics/img/newlist/8.27/01.jpg" alt="">
                <div class="slide4s-1" @click="jumpdetail(9)">
                    <div class="slide4s-1-l">
                        <p>{{newdata[0].time.year}}</p>
                        <span>{{newdata[0].time.month}}-{{newdata[0].time.day}}</span>
                    </div>
                    <div class="slide4s-1-r">
                        <p>{{newdata[0].title}}</p>
                        <span>{{newdata[0].content}}</span>
                    </div>
                </div>
            </div>
            <div class="slide4ss" @click="jumpdetail(8)">
                <div class="slide4s-1-l">
                    <p>{{newdata[1].time.year}}</p>
                    <span>{{newdata[1].time.month}}-{{newdata[1].time.day}}</span>
                </div>
                <div class="slide4s-1-r">
                    <p>{{newdata[1].title}}</p>
                    <span>{{newdata[1].content}}</span>
                </div>
            </div>
            <div class="slide4ss" @click="jumpdetail(7)">
                <div class="slide4s-1-l">
                    <p>{{newdata[2].time.year}}</p>
                    <span>{{newdata[2].time.month}}-{{newdata[2].time.day}}</span>
                </div>
                <div class="slide4s-1-r">
                    <p>{{newdata[2].title}}</p>
                    <span>{{newdata[2].content}}</span>
                </div>
            </div>
            <div class="more" @click="jumpviews()">
                more
            </div>
        </div>
        <bot_mobile></bot_mobile>
    </div>

</template>

<script>
    import top_mobile from "../components/top_mobile";
    import bot_mobile from "../components/bot_mobile";
    import news from "../../public/statics/newsdata"
    export default {
        name: "index_mobile",
        data() {
            return {
                topshow:true,
                newdata: [],

            }
        },
        watch:{

        },
        components: {
            top_mobile, bot_mobile
        },
        created(){
            let arr = news.newslist.slice(0, 3);
            this.newdata = JSON.parse(JSON.stringify(arr));
        },
        mounted() {
            window.addEventListener('scroll',this.handleScrollx,true)
        },
        methods: {
            handleScrollx() {
                if(window.pageYOffset>85){
                    this.topshow=false;
                }else{
                    this.topshow=true;
                };
            },
            jumpviews(){
                this.$router.push({
                    path: '/newviews_mobile'
                })
            },
            toapply() {
                this.$router.push({
                    path: '/edition_mobile'
                })
            },
            jumpdetail(e){
                this.$router.push({
                    path: '/newviewsdetails_mobile',
                    query: {id: e}
                })
            },
        },
    }
</script>

<style scoped lang='scss'>
    .index_mobile {
        width: 100%;
        /*height: 100%;*/
        height: 100vh;
        /*background: #005f88;*/
        .slide1 {
            position: relative;

            img {
                width: 100%;
                height: auto;
            }

            .slide1img01 {
                position: absolute;
                left: 0;
                right: 0;
                top: 45%;
                margin: auto;
                width: 8rem;
                height: auto;
            }

            .slide1img02 {
                position: absolute;
                left: 0;
                right: 0;
                top: 60%;
                margin: auto;
                width: 4rem;
                height:auto;
                border-radius:40px;
                img{
                    width: 100%;
                }

            }

            .slide1bot {
                position: absolute;
                bottom: -20px;
                left: 0;
                right: 0;
                margin: auto;
                width: 20rem;
                height: 50px;
                padding: 5px;
                box-sizing: border-box;
                display: flex;
                justify-content: space-around;
                align-items: center;
                background: rgba(12, 13, 13, 0.8);

                .slide1bots {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    color: #fff;

                    p {
                        font-size: 14px;
                        margin-bottom: 4px;
                    }

                    span {
                        font-size: 12px;
                    }
                }

                .slide1botsb {
                    width: 2px;
                    height: 1rem;
                    background: #fff;
                }

            }

        }

        .slide2 {
            margin-top: 2rem;

            .slide2img {
                width: 100%;
            }

            .slide2font {
                padding: 0.5rem;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: center;
                font-family: "PingFang SC";
                text-align: left;

                .slide2font1 {
                    width: 2rem;
                    height: 2px;
                    background: #000;
                    margin: 5px 0;
                }

                .slide2font2 {
                    margin-top: 5px;
                    font-size: 16px;
                    color: #000;
                }

                .slide2font3 {
                    margin-top: 5px;
                    font-size: 12px;
                    color: #999999;
                }

                .slide2font4 {
                    font-size: 12px;
                    color: #777;
                }

            }
        }

        .slide3 {
            margin-top: 2rem;

            .slide2img {
                width: 100%;
            }

            .slide2font {
                padding: 0.5rem;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                justify-content: center;
                font-family: "PingFang SC";
                text-align: right;

                .slide2font1 {
                    width: 3rem;
                    height: 2px;
                    background: #000;
                    margin: 5px 0;
                }

                .slide2font2 {
                    font-size: 16px;
                    line-height: 20px;
                    color: #000;
                }

                .slide2font3 {
                    font-size: 14px;
                    line-height: 16px;
                    color: #666;
                }

                .slide2font4 {
                    font-size: 12px;
                    line-height: 16px;

                    color: #777;
                }

            }
        }

        .slide4 {
            margin-top: 2rem;
            font-family: "PingFang SC";

            .slide4title1 {
                font-size: 16px;
                color: #3A3B3B;
                margin-bottom: 0.5rem;
            }

            .slide4title2 {
                font-size: 12px;
                color: #C3C7CC;
                margin-bottom: 0.5rem;

            }

            .slide4s {
                background: #F7F7F7;
                padding: 1rem;
                box-sizing: border-box;

                img {
                    width: 100%;
                    height: auto;
                    border-radius: 3px;
                }

                .slide4s-1 {
                    margin-top: 1rem;
                    width: 100%;
                    display: flex;
                    justify-content: space-between;

                    .slide4s-1-l {
                        width: 3rem;
                        display: flex;
                        flex-direction: column;

                        p {
                            color: #9D9C99;
                            font-size: 16px;
                        }

                        span {
                            color: #9D9C99;
                            font-size: 12px;
                        }
                    }

                    .slide4s-1-r {
                        width: 18rem;
                        display: flex;
                        flex-direction: column;
                        text-align: left;
                        justify-content: center;

                        p {
                            width: 100%;
                            line-height: 20px;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            display: block;
                            color: #717479;
                        }

                        span {
                            width: 100%;
                            line-height: 20px;

                            color: #B0B0B2;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            display: block;
                        }
                    }

                }
            }

            .slide4ss {
                margin-top: 0.5rem;
                padding: 1rem;
                background: #F7F7F7;
                box-sizing: border-box;
                width: 100%;
                display: flex;
                justify-content: space-between;

                .slide4s-1-l {
                    width: 3rem;
                    display: flex;
                    flex-direction: column;

                    p {
                        color: #9D9C99;
                        font-size: 16px;
                    }

                    span {
                        color: #9D9C99;
                        font-size: 12px;
                    }
                }

                .slide4s-1-r {
                    width: 18rem;
                    display: flex;
                    flex-direction: column;
                    text-align: left;
                    justify-content: center;

                    p {
                        width: 100%;
                        line-height: 20px;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        display: block;
                        color: #717479;
                    }

                    span {
                        width: 100%;
                        line-height: 20px;

                        color: #B0B0B2;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        display: block;
                    }
                }
            }

            .more {
                width: 10rem;
                height: 30px;
                line-height: 30px;
                font-size: 16px;
                color: #8F8F8F;
                border: 1px solid #E5E5E5;
                border-radius: 6px;
                margin: 1rem auto;
                margin-bottom: 1rem;
            }
        }
        .slide-fade-enter-active {transition: all .2s ease;}
        .slide-fade-leave-active {transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);}
        .slide-fade-enter, .slide-fade-leave-to{transform: translateX(5px);opacity: 0;}

    }


</style>